export function installIntlSegmenter() {
  // no-op
}
